/**
 * Vuex store module for content editor functionality.
 *
 * @module store/modules/editor
 * @description Manages state for content node editing, including tracking changes,
 * upload status, connected nodes analysis, and trigger differences for version control.
 *
 * @example
 * // Access state
 * this.$store.state.editor.updateContentNode
 *
 * // Dispatch action
 * this.$store.dispatch('GET_CONNECTED_NODES', nodeId)
 *
 * // Access getter
 * this.$store.getters.connectedNodes
 */
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { EditorState } from "./types";
import { RootState } from "@/store/types";

const editor: Module<EditorState, RootState> = {
  // namespaced: true,
  getters,
  state,
  actions,
  mutations,
};

export default editor;
